var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._b({staticClass:"ui-input",domProps:{"value":_vm.newValue},on:{"input":_vm.onInput}},'input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }